<template>
  <div v-if="uploadType === 'img'" class="img-upload">
    <el-upload
      class="upload-demo"
      action="#"
      :multiple="multiple"
      :show-file-list="showFileList"
      :accept="fileType.toString()"
      :before-upload="beforeUpload"
      :on-preview="handlePictureCardPreview"
      :on-remove="handleRemove"
      :file-list="fileList"
      :list-type="listType"
      :http-request="uploadImg"
      :on-change="handleChange"
    >
      <template
        v-if="
          listType === 'picture-card' || listType === '' || listType === null
        "
      >
        <i class="el-icon-plus"></i>
      </template>
      <template v-else>
        <el-button size="small" type="primary">{{ buttonText }}</el-button>
      </template>
      <div v-if="isShowPromptText" slot="tip" class="el-upload__tip">
        {{ promptText }}
      </div>
    </el-upload>
    <el-image-viewer
      style="z-index: 3000"
      v-if="imgDialog"
      :urlList="[dialogImageUrl]"
      :on-close="imageViewerClose"
    ></el-image-viewer>
  </div>
  <div v-else-if="uploadType === 'onePicture'" class="img-upload">
    <el-upload
      class="avatar-uploader"
      action="#"
      :show-file-list="false"
      :accept="fileType.toString()"
      :before-upload="beforeUpload"
      :on-preview="handlePictureCardPreview"
      :on-remove="handleRemove"
      :http-request="uploadImg"
    >
      <img
        v-if="fileList.length > 0"
        :src="fileList && fileList[0].url"
        class="avatar"
      />
      <i v-else-if="value === ''" class="el-icon-plus avatar-uploader-icon" />
      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      <span
        v-if="fileList.length > 0"
        class="el-upload-list__item-actions"
        @click.stop
      >
        <span
          class="el-upload-list__item-preview"
          @click="handlePictureCardPreview(fileList[0])"
        >
          <i class="el-icon-zoom-in"></i>
        </span>
        <span
          class="el-upload-list__item-del"
          @click="handleRemove(fileList[0])"
        >
          <i class="el-icon-delete"></i>
        </span>
      </span>
    </el-upload>
    <el-image-viewer
      style="z-index: 3000"
      v-if="imgDialog"
      :urlList="[dialogImageUrl]"
      :on-close="imageViewerClose"
    ></el-image-viewer>
  </div>
  <div v-else-if="uploadType === 'custom'">
    <el-upload
      action="#"
      :http-request="uploadImg"
      :file-list="fileList"
      v-bind="$attrs"
      v-on="$listeners"
    >
      <slot
        v-for="(_, slotName) in $slots"
        :name="slotName"
        :slot="slotName"
      ></slot>
    </el-upload>
  </div>
  <div v-else class="file-upload">
    <el-upload
      class="upload-demo"
      action="#"
      :multiple="multiple"
      :show-file-list="showFileList"
      :accept="fileType.toString()"
      :before-upload="beforeUpload"
      :on-remove="handleRemove"
      :file-list="fileList"
      :list-type="listType"
      :http-request="uploadImg"
    >
      <template v-if="listType === 'picture-card'">
        <i class="el-icon-plus"></i>
      </template>
      <template v-else>
        <el-button size="small" type="primary">{{ buttonText }}</el-button>
      </template>
      <div v-if="isShowPromptText" slot="tip" class="el-upload__tip">
        {{ promptText }}
      </div>
    </el-upload>
  </div>
</template>
<script>
import { Upload } from "element-ui";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import SparkMD5 from "spark-md5";
import { clearTimeout } from "timers";

function awaitFn(fn) {
  return new Promise((resolve, reject) => {
    fn.then((res) => {
      resolve([null, res]);
    }).catch((err) => {
      resolve([err, null]);
    });
  });
}

function fileToMd5(file) {
  return new Promise((resolve, reject) => {
    const blobSlice =
        File.prototype.slice ||
        File.prototype.mozSlice ||
        File.prototype.webkitSlice,
      chunkSize = 2097152, // Read in chunks of 2MB
      chunks = Math.ceil(file.size / chunkSize),
      spark = new SparkMD5.ArrayBuffer(),
      fileReader = new FileReader();
    let currentChunk = 0;
    function loadNext() {
      const start = currentChunk * chunkSize,
        end = start + chunkSize >= file.size ? file.size : start + chunkSize;
      fileReader.readAsArrayBuffer(blobSlice.call(file, start, end));
    }

    fileReader.onload = function (e) {
      console.log("read chunk nr", currentChunk + 1, "of", chunks);
      spark.append(e.target.result); // Append array buffer
      currentChunk++;

      if (currentChunk < chunks) {
        loadNext();
      } else {
        console.log("finished loading");
        const result = spark.end(); // 必须先调用赋值
        console.info("computed hash", result); // Compute hash
        resolve(result);
      }
    };

    fileReader.onerror = function () {
      console.warn("oops, something went wrong.");
    };

    loadNext();
  });
}
// 发送upload上传分片文件请求
function uploadPipe(uploadObj, file) {
  const reqData = new FormData();
  Object.keys(uploadObj.params).forEach((key) => {
    reqData.append(key, uploadObj.params[key]);
  });
  reqData.append("file", file, file.name);
  return new Promise((resolve, reject) => {
    fetch(uploadObj.host, {
      method: uploadObj.method,
      body: reqData
    })
      .then((res) => res.json())
      .then((res) => {
        console.log("fetch success", res);
        resolve({
          id: res.contextId,
          name: res.filename,
          url: res.url
        });
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export default {
  name: "FileUpload",
  components: {
    [Upload.name]: Upload,
    ElImageViewer
  },
  props: {
    listType: {
      // 对应elementui的upload组件中的listtype
      type: String,
      default: null
    },
    value: {
      // 上传文件的列表
      type: Array,
      required: true
    },
    uploadType: {
      // 上传类型  文件 or 图片 or 单张图片
      type: String,
      default: "img",
      validator: function (value) {
        return ["img", "other", "onePicture", "custom"].indexOf(value) !== -1;
      }
    },
    buttonText: {
      // 上传按钮的文字
      type: String,
      default: "点击上传"
    },
    fileType: {
      // 允许上传文件类型，字符串数组格式  例如['.jpg', '.png', '.jpeg', '.gif']
      type: Array
    },
    fileSize: {
      // 允许上传文件大小
      type: Number,
      default: 5
    },
    multiple: {
      // 是否允许多选
      type: Boolean,
      default: true
    },
    isShowPromptText: {
      // 是否显示下面提示文字
      type: Boolean,
      default: true
    },
    showFileList: {
      // 是否显示文件列表
      type: Boolean,
      default: true
    },
    // 返回的结构 Promise -> { url: '', id: '', name: '' }
    checkFn: {
      // 上传的参数
      type: Function,
      required: true
    },
    prepareFn: {
      // 上传的参数
      type: Function,
      required: true
    },
    completeFn: {
      // 上传的参数
      type: Function,
      required: true
    },
    // 分片大小
    chunkSize: {
      type: Number,
      default: 10 * 1024 * 1024 // 10M
    },
    // 同时并发的最大请求个数
    maxFetchCount: {
      type: Number,
      default: 6
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      fileList: [], // 已经上传文件的列表  拼接了文件服务器地址的
      imgDialog: false, // 图片查看弹窗是否显示
      dialogImageUrl: "", // 图片弹窗中图片链接
      promptText: "" // 提示信息
    };
  },
  watch: {
    value: {
      handler(newValue, oldValue) {
        // 监听v-model绑定值value，value值改变时，随时改变自身fileList中值
        this.fileList = (newValue || []).map((item) => {
          return {
            id: item.id,
            name: item.name,
            url: item.url
          };
        });
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    console.log(this.uploadType, this.listType, ">>>");
    // 生成提示信息
    if (this.fileType && this.fileType.length) {
      this.promptText =
        "只能上传" +
        this.fileType.toString() +
        "文件，且大小不能超过" +
        this.fileSize +
        "M";
    }
  },
  methods: {
    handleChange() {
      console.log("change");
      if (!this.isLoading) {
        this.$emit("update:isLoading", true);
      }
    },
    // 上传之前，检查文件类型和文件大小  如果是头像单文件上传，上传前检查是否已经上传头像，已上传，要删除
    beforeUpload(file) {
      console.log("beforeUpload");
      /**
       * 检查文件大小
       */
      if (file.size / 1024 / 1024 > this.fileSize) {
        this.$message({
          type: "error",
          message: `文件大小超过${this.fileSize}M`
        });
        return false;
      }
      /**
       * 检查文件类型  利用文件名的后缀名来判断文件类型
       */
      const type = file.name.split(".")[file.name.split(".").length - 1];
      if (this.fileType.indexOf("." + type) < 0) {
        this.$message({
          type: "error",
          message: `文件类型错误`
        });
        return false;
      }
      /**
       * 头像单文件上传
       */
      if (this.uploadType === "onePicture") {
        if (this.fileList.length > 0) {
          this.handleRemove(this.fileList[0]);
        }
        return true;
      }
    },
    genFile(file) {
      let ext = "";
      if (file.name) {
        const fArr = file.name.split(".");
        ext = fArr.pop();
      }
      ext = ext || (file.type || "").split("/").pop();
      return {
        ext,
        fileName: file.name
      };
    },
    /* NOSONAR */ fileUpload({ file, chunkSize = 10 * 1024 * 1024, maxFetchCount = 6 }) {
      // 没有上传过先调用预上传接口
      const { ext, fileName } = this.genFile(file);
      // 后缀名取不到的话代表是有问题的文件，直接返回空
      if (!ext || !fileName) {
        console.log("该文件有问题，取不到文件名");
        return Promise.resolve();
      }
      return new Promise((resolve, reject) => {
        fileToMd5(file)
          .then(async (md5) => {
            const [err, res] = await awaitFn(
              this.checkFn({
                md5,
                fileName
              })
            );
            // check接口失败直接返回空
            if (err) {
              console.log(err, err.message, "check catch");
              resolve();
              return;
            }
            // check返回有值的话，直接返回成功数据
            if (res) {
              resolve(res);
              return;
            }
            const [err1, res1] = await awaitFn(
              this.prepareFn({
                ext,
                chunks:
                  file.size > chunkSize ? Math.ceil(file.size / chunkSize) : 0,
                filename: fileName,
                fileName: fileName
              })
            );
            if (err1) {
              console.log(err, err.message, "prepare catch");
              resolve();
              return;
            }
            // 请求接口数组总数量
            const uploads = res1.uploads;
            const len = uploads.length;
            if (len === 1) {
              const [err2, res2] = await awaitFn(uploadPipe(uploads[0], file));
              if (err2) {
                console.log(err, "uploadPipe catch");
                resolve();
              } else {
                resolve(res2);
              }
            } else {
              let count = 0;
              const successRes = [];
              const next = () => {
                const current = count++;
                if (current >= len) {
                  return;
                }
                uploadPipe(uploads[current], file)
                  .then((res) => {
                    successRes.push(res);
                    if (current < len) {
                      next();
                    }
                  })
                  .catch((err) => {
                    successRes.push(err);
                    if (current < len) {
                      next();
                    }
                  })
                  .finally(async () => {
                    if (successRes.length === uploads.length) {
                      const [err3, res3] = await awaitFn(
                        this.completeFn({
                          contextId: uploads[0].params.contextId,
                          filename: fileName,
                          fileName: fileName,
                          md5
                        })
                      );
                      if (err3) {
                        console.log(err3, "complete catch");
                        resolve();
                      } else {
                        console.log(res3, "complete then");
                        resolve(res3);
                      }
                    }
                  });
              };
              // 请求maxNum个
             /* NOSONAR */ while (count < maxFetchCount) {
                next();
              }
            }
          })
          .catch((err) => {
            console.log(err, err.message, "fileToMd5 catch");
            reject(err);
          });
      });
    },
    // 上传图片到系统文件
    uploadImg({ file }) {
      this.fileUpload({
        file: file,
        chunkSize: this.chunkSize,
        maxFetchCount: this.maxFetchCount
      }).then((res) => {
        if (!res) {
          return;
        }
        const fileObj = {
          id: res.id,
          name: res.name,
          url: res.url
        };
        if (this.uploadType === "onePicture" || !this.multiple) {
          this.$emit("input", [fileObj]);
        } else {
          this.$emit("input", [...this.value, fileObj]);
        }
      });
    },
    // 删除图片  服务器中删除   fileList中删除   value中删除
    handleRemove(file) {
      this.$emit(
        "input",
        this.value.filter((item) => item.id !== file.id)
      );
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.imgDialog = true;
    },
    imageViewerClose() {
      this.imgDialog = false;
    }
  }
};
</script>
<style lang="scss">
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.el-upload-list__item-actions {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  cursor: default;
  text-align: center;
  color: #fff;
  opacity: 0;
  font-size: 20px;
  background-color: rgba(0, 0, 0, 0.5);
  transition: opacity 0.3s;
  display: flex;
  justify-content: center;
  align-items: center;
  &:hover {
    opacity: 1;
  }
  .el-upload-list__item-del {
    margin-left: 10px;
  }
}
</style>
